import React from 'react';
import { OpsShellLayout, type OpsNavGroup } from '../ui/OpsShellLayout';

const GROUPS: OpsNavGroup[] = [
  {
    id: 'judging',
    label: 'Judging',
    items: [
      {
        name: 'Assigned events',
        href: '/judge',
        description: 'Open a list and score vehicles',
        isActive: (pathname) => pathname === '/judge' || pathname.startsWith('/judge/events/'),
      },
    ],
  },
  {
    id: 'browse',
    label: 'Browse',
    items: [
      {
        name: 'Public events',
        href: '/events',
        description: 'Event pages and archives',
      },
    ],
  },
];

/**
 * Judge workspace shell with persistent sidebar navigation.
 */
const JudgeLayout: React.FC = () => (
  <OpsShellLayout
    title="Judge"
    roleLabel="Assigned judge"
    navAriaLabel="Judge"
    homeHref="/judge"
    tip="Score assigned classes. Drafts save until you finalize."
    groups={GROUPS}
  />
);

export default JudgeLayout;
